<template>
	<RouterView></RouterView>
</template>
